export const controlButtonDiameter = '29px';
